export const COLORS = {
  BlackText: "#151414ff",
  blackColor: "#280101ff",
  WhiteText: "#FFFFFF",
  WhiteBackground: "#FFFFFF",
  activeBackground: "#D9D9D914",
  MainColor: "#1976d2",
  SUCCESS: "#20ce60ff",
  BorderColor: "#e0e0e0",
  textFieldBackgroundColor: "#E0E0E0",
  placeHolderColor: "#868585",
  RED: "#eb0000ff",
  typographyColor: "#1C1C1C",
  SidebarActiveBg: "#e0f2ff",
  SidebarActiveText: "#2563eb",
  SidebarInactiveText: "#6b7280",
  MainBackground: "#f7f7f7",
};
